import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { RefreshCw, Loader2 } from 'lucide-react';
import InfoTip from './InfoTip';

// Contenedor común para cada sección del reporte 360 v2.
// Maneja loading, error y botón de recarga individual.
const SectionCard = ({ title, hint, info, action, loading, error, onReload, children, className = '' }) => {
  return (
    <Card className={`rounded-xl border border-gray-200/80 dark:border-gray-700/80 bg-white dark:bg-gray-800 shadow-sm ${className}`}>
      <div className="px-5 pt-5 pb-3 flex items-start justify-between gap-3">
        <div>
          <h2 className="text-base font-bold text-[#001F41] dark:text-white tracking-tight flex items-center gap-1.5">
            {title}
            {info && <InfoTip>{info}</InfoTip>}
          </h2>
          {hint && <p className="text-[11.5px] text-[#43474F] dark:text-gray-400 mt-0.5">{hint}</p>}
        </div>
        <div className="flex items-center gap-2">
          {action}
          {onReload && (
            <button
              type="button"
              onClick={onReload}
              disabled={loading}
              className="text-[#0F3460] dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full p-1.5 transition-colors disabled:opacity-50"
              title="Recargar sección"
            >
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <RefreshCw className="h-4 w-4" />}
            </button>
          )}
        </div>
      </div>
      <CardContent className="px-5 pb-5 pt-0">
        {error ? (
          <div className="text-sm text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20 rounded-lg p-3">
            {error}
          </div>
        ) : loading && !children ? (
          <div className="flex items-center justify-center py-8 text-sm text-gray-500">
            <Loader2 className="h-4 w-4 animate-spin mr-2" /> Cargando…
          </div>
        ) : (
          children
        )}
      </CardContent>
    </Card>
  );
};

export default SectionCard;
